import {
  SLA_CREATE_STEP_WIDTH_LANDLORD_CONTRACT,
  SLA_CREATE_STEP_WIDTH_LANDLORD_REVIEW,
  SLA_CREATE_STEP_WIDTH_OEM_CONTRACT,
  SLA_CREATE_STEP_WIDTH_OEM_REVIEW,
  SLA_CREATE_STEP_WIDTH_PARTNER,
  SLA_CREATE_STEP_WIDTH_SCOPE,
  SLA_MODAL_SHELL_MAX_HEIGHT,
  SLA_MODAL_SHELL_MAX_HEIGHT_REVIEW,
  SLA_MODAL_WIDTH_LANDLORD_EDIT,
  SLA_MODAL_WIDTH_OEM_EDIT,
} from '@/app/landing/sla/shared/sla.constants';

export type SlaPartnerKind = 'landlord' | 'oem';
export type SlaCreateStep = 0 | 1 | 2 | 3;

export type SlaModalLayout = {
  width: string;
  /** Viewport-constrained modal; body scrolls, footer always visible. */
  pinFooter: boolean;
  shellMaxHeight?: string;
  scrollBody?: boolean;
  maxBodyHeight?: string;
};

const LANDLORD_CREATE_STEP_LAYOUTS: Record<SlaCreateStep, SlaModalLayout> = {
  0: { width: SLA_CREATE_STEP_WIDTH_PARTNER, pinFooter: false },
  1: { width: SLA_CREATE_STEP_WIDTH_SCOPE, pinFooter: false },
  2: {
    width: SLA_CREATE_STEP_WIDTH_LANDLORD_CONTRACT,
    pinFooter: true,
    shellMaxHeight: SLA_MODAL_SHELL_MAX_HEIGHT,
  },
  3: {
    width: SLA_CREATE_STEP_WIDTH_LANDLORD_REVIEW,
    pinFooter: true,
    shellMaxHeight: SLA_MODAL_SHELL_MAX_HEIGHT_REVIEW,
  },
};

const OEM_CREATE_STEP_LAYOUTS: Record<SlaCreateStep, SlaModalLayout> = {
  0: { width: SLA_CREATE_STEP_WIDTH_PARTNER, pinFooter: false },
  1: { width: SLA_CREATE_STEP_WIDTH_SCOPE, pinFooter: false },
  2: {
    width: SLA_CREATE_STEP_WIDTH_OEM_CONTRACT,
    pinFooter: true,
    shellMaxHeight: SLA_MODAL_SHELL_MAX_HEIGHT,
  },
  3: {
    width: SLA_CREATE_STEP_WIDTH_OEM_REVIEW,
    pinFooter: true,
    shellMaxHeight: SLA_MODAL_SHELL_MAX_HEIGHT_REVIEW,
  },
};

function clampCreateStep(step: number): SlaCreateStep {
  if (step <= 0) {
    return 0;
  }
  if (step >= 3) {
    return 3;
  }
  return step as SlaCreateStep;
}

export function resolveSlaModalLayout(params: {
  partnerKind: SlaPartnerKind;
  isEdit: boolean;
  createStep?: number;
}): SlaModalLayout {
  if (params.isEdit) {
    return {
      width:
        params.partnerKind === 'landlord'
          ? SLA_MODAL_WIDTH_LANDLORD_EDIT
          : SLA_MODAL_WIDTH_OEM_EDIT,
      pinFooter: true,
      scrollBody: true,
    };
  }

  const step = clampCreateStep(params.createStep ?? 0);
  const layouts =
    params.partnerKind === 'landlord'
      ? LANDLORD_CREATE_STEP_LAYOUTS
      : OEM_CREATE_STEP_LAYOUTS;

  return layouts[step];
}
